






















































import { BusinessOpeningHours } from '@/models/businesses/business-opening-hours';
import { Prop, Vue, Component } from 'vue-property-decorator';
import { mdbAlert, mdbBtn, mdbCard, mdbCardBody, mdbCardTitle, mdbIcon, mdbInput, mdbTbl, mdbTblBody, mdbTooltip } from '@folky-tools/mdbvue';

@Component({
    components: {
        mdbAlert,
        mdbBtn,
        mdbCard,
        mdbCardBody,
        mdbCardTitle,
        mdbIcon,
        mdbInput,
        mdbTbl,
        mdbTblBody,
        mdbTooltip
    }
})
export default class OpeningHours extends Vue {
    @Prop(Boolean) private canWrite!: boolean;
    @Prop(BusinessOpeningHours) private openingHours!: BusinessOpeningHours;
    @Prop(Boolean) private showTimeTableMissingAlert!: boolean;
    @Prop(Boolean) private pageContentLoaded!: boolean;

    private editBusinessOpeningHours(): void {
        this.$emit('clicked-edit-opening-hours');
    }
}
